
import NewSkeletonBox from '~/components/common/loading/skeleton/NewSkeletonBox.vue'

export default {
  name: 'ProductGridSkeleton',
  components: {
    NewSkeletonBox
  },
  props: {
    unitRatio: {
      type: String,
      default: '16.667'
    },
    unitCount: {
      type: Number,
      default: 6
    },
    isRankingProd: {
      type: Boolean,
      default: false
    }
  }
}
